import { VendorCitation } from '@/components/ui/citation-chip';
import { WorkspaceButton, WorkspaceDialog } from '@/components/ui/workspace';
import type { ReportCitation } from '@/lib/api/vendor-intelligence-report';
import { toVendorCitation } from './report-logic';

const KIND_LABEL: Record<string, string> = {
  vendor_knowledge_item: 'Vendor knowledge base item',
  vendor_area_rating: 'Confirmed rating',
  engagement_requirement: 'Requirement',
  discovery_pain_point: 'Discovery pain point',
};

/**
 * One citation of the report, as the client will read it in the PDF's
 * evidence list: the full excerpt and where it comes from. A source a
 * vendor shared is quoted in full too (owner decision, 23 October 2026),
 * and says so.
 */
export function CitationDialog({
  citation,
  onClose,
}: {
  citation: ReportCitation | null;
  onClose: () => void;
}) {
  return (
    <WorkspaceDialog
      open={citation !== null}
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
      title={citation ? (citation.code ?? citation.label) : ''}
      description={citation ? (KIND_LABEL[citation.kind] ?? 'Source') : undefined}
      actions={<WorkspaceButton onClick={onClose}>Close</WorkspaceButton>}
    >
      {citation ? (
        <div className="flex flex-col gap-2 text-body-sm text-ink-700">
          {citation.statement ? <p className="m-0 text-ink-900">{citation.statement}</p> : null}
          <VendorCitation citation={toVendorCitation(citation)} className="mt-0" />
          {citation.confidential ? (
            <p className="m-0 text-meta text-ink-500">
              A vendor shared this source. The report quotes it in full.
            </p>
          ) : null}
        </div>
      ) : null}
    </WorkspaceDialog>
  );
}
